export const mod = (n, d) => ((n % d) + d) % d;

const widthToString = {
  2: 'two',
  4: 'four',
  6: 'six',
  8: 'eight',
  10: 'ten',
  12: 'twelve',
  14: 'fourteen',
  16: 'sixteen',
}

export const widthSize = width => mod(width, 2) === 0 ? Math.min(Math.max(width, 2), 16) : 2;
export const widthSizeText = width => mod(width, 2) === 0 ? widthToString[Math.min(Math.max(width, 2), 16)] : '';